import { DataGrid, DataGridProps } from "@mui/x-data-grid";
import React from "react";
import useUpdateDataGridLanguage from "../../custom-hooks/useUpdateDataGridLanguage/useUpdateDataGridLanguage";

const LocalizedDataGrid = React.forwardRef<HTMLDivElement, DataGridProps>((props, ref) => {
  const muiLanguage = useUpdateDataGridLanguage();
  const { apiRef: apiRefFromProps, ...rest } = props;
  return (
    <>
      <DataGrid
        ref={ref}
        apiRef={apiRefFromProps}
        {...rest}
        localeText={muiLanguage.components.MuiDataGrid.defaultProps.localeText}
      />
    </>
  );
});

LocalizedDataGrid.displayName = "LocalizedDataGrid";

export default LocalizedDataGrid;
